import template from './forgot-password.html';
import './forgot-password.styl';

function forgotPasswordComponent($tszToast, $translate, AuthService) {

  'ngInject';

  this.loading = false;

  this.forgotPassword = (form) => {

    if (form.$valid) {
      this.loading = true;
    }

    AuthService.forgotPassword(this.data.email)
    .then(() => {
      $tszToast.showSuccess('Se ha enviado un email con instrucciones para cambiar su contraseña');
    }).catch((err) => {
      if (err.data && err.data.code) {
        $translate(`ERROR.${err.data.code}`)
        .then((errorMsg) => {
          $tszToast.showError(errorMsg);
          this.error = errorMsg;
        });
      }
    }).finally(() => {
      // regardless of the response, change the loading state
      this.loading = false;
    });

  };
}

export default {
  template,
  controller: forgotPasswordComponent,
};



// WEBPACK FOOTER //
// ./src/containers/forgot-password/index.js